<script>
import baseList from '@/views/components/base/baseList.vue'
import { Avatar, Button, Card, Col, Row } from 'view-design'
import you from '@/assets/icon/you.png'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: 'water',
        key: 'id',
        url: {},
        output: false,
      },
      data: {},
      menus: [
        {
          label: '加水列表',
          name: 'water_list',
          auth: '/admin/water/lists',
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        // {
        //   label: "评论列表",
        //   name: "water_list",
        //   //   auth: "/admin/water/lists",
        //   // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        // },
      ],
      actions: [],
      tactions: [
        { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '加水数据', 0), auth: '/admin/water/lists' },
        { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '加水数据', 1), auth: '/admin/water/lists' },
      ],
      query: {},
      currentRow: null,
      filters: [
        { label: '加水人', name: 'publish_name', value: '', type: 'input' },
        { label: '加水内容', name: 'content', value: '', type: 'input' },
        {
          label: '加水日期',
          name: 'create_time',
          value: '',
          type: 'datetimerange',
        },
      ],
      tableCols: [
        {
          type: 'selection',
          width: 60,
        },
        {
          title: 'ID',
          width: 100,
          key: 'id',
        },
        {
          title: '加水人',
          key: 'publish_name',
          width: 150,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.publish_name
            let src = row.publish_head
            let uid = row.publish_uid
            return h(
              'div',
              {
                style: {
                  height: '34px',
                  lineHeight: '34px',
                  overflow: 'hidden',
                },
              },
              [
                h('Avatar', {
                  props: {
                    src: src,
                  },
                  attrs: {
                    title: 'UID: ' + uid,
                  },
                  style: {},
                }),
                h(
                  'span',
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: '5px',
                      width: 'auto',
                      height: '34px',
                      overflow: 'hidden',
                    },
                  },
                  uname
                ),
              ]
            )
          },
        },
        {
          title: '得水人',
          key: 'by_name',
          width: 150,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.by_name
            let src = row.by_head
            let uid = row.by_uid
            return h(
              'div',
              {
                style: {
                  height: '34px',
                  lineHeight: '34px',
                  overflow: 'hidden',
                },
              },
              [
                h('Avatar', {
                  props: {
                    src: src,
                  },
                  attrs: {
                    title: 'UID: ' + uid,
                  },
                  style: {},
                }),
                h(
                  'span',
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: '5px',
                      width: 'auto',
                      height: '34px',
                      overflow: 'hidden',
                    },
                  },
                  uname
                ),
              ]
            )
          },
        },
        {
          title: '加水数量',
          minWidth: 100,
          key: 'water_num',
          render: (h, { row }) => <span style={{ color: '#3E8BED', fontWeight: 500 }}>{row.water_num} 勺</span>,
        },
        {
          title: '加水时间',
          minWidth: 100,
          key: 'create_time',
        },
        {
          title: '内容',
          minWidth: 200,
          key: 'content',
        },
        {
          title: '图集',
          minWidth: 100,
          key: 'gallery',
          viewimages: true,
        },
        {
          title: '评论数量',
          minWidth: 100,
          key: 'comment_count',
        },
        {
          title: '状态',
          align: 'center',
          key: 'status',
          minWidth: 100,
          switch: true,
          disabled: false,
        },
        {
          title: '是否精选',
          align: 'center',
          key: 'is_choiceness',
          minWidth: 100,
          render: (h, currentRow) => {
            let row = currentRow.row
            let directives = [{ name: 'auth', value: '/admin/water/edit' }]
            return h(
              'i-switch',
              {
                // 自定义指令
                directives: directives,
                props: {
                  size: 'small',
                  value: row.is_choiceness == 1 ? true : false,
                  // disabled: param.column.disabled ? true : false,
                },
                style: {
                  margin: '4px 5px',
                },
                on: {
                  'on-change': () => {
                    this.handleSwitch(row)
                  },
                },
              },
              '开关'
            )
          },
        },
        {
          title: '订阅消息发送结果',
          minWidth: 150,
          key: 'sub_msg',
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 250,
          key: 'handle',
          fixed: 'right',
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row
              let directives = [{ name: 'auth', value: '/admin/water/get' }]
              return (
                <Button {...{ directives }} size="small" onClick={() => this.Detail(currentRow)} type="info" style={{ margin: '4px 5px' }}>
                  详情
                </Button>
              )
            },
            'delete',
            (vm, h, currentRow, param) => {
              const row = param.row
              let directives = [{ name: 'auth', value: '/admin/water_comment/get' }]
              return (
                <Button {...{ directives }} size="small" onClick={() => this.ToWater_comment(currentRow)} type="success">
                  评论列表
                </Button>
              )
            },
          ],
          auth: {
            del: '/admin/reverb/del',
          },
        },
      ],
    }
  },
  created() {},

  methods: {
    ToWater_comment(row) {
      $utils.url.push({
        name: 'water_comment',
        query: {
          // action: "water_comment",
          id: row.id,
        },
      })
    },
    Detail(row) {
      this.$Modal.info({
        width: 600,
        closable: true,
        render: () => (
          <div class="renBox">
            <Card bordered={false} dis-hover>
              <p slot="title">
                <strong>加水详情</strong>
              </p>
              <Card dis-hover padding={0} bordered={false} class="item">
                <Row align="middle" gutter={20}>
                  <Col>
                    <Avatar shape="square" size="large" src={row.publish_head} />
                    <p class="name">{row.publish_name}</p>
                  </Col>
                  <Col>
                    <p>
                      <strong>{row.water_num}</strong> 勺
                    </p>
                    <img src={you} />
                  </Col>
                  <Col>
                    <Avatar shape="square" size="large" src={row.by_head} />
                    <p class="name">{row.by_name}</p>
                  </Col>
                </Row>
              </Card>

              <Card dis-hover padding={0} bordered={false} class="item">
                <Row justify="space-between">
                  <Col class="Item_title">
                    <strong>加水时间</strong>
                  </Col>
                  <Col>{row.create_time}</Col>
                </Row>
              </Card>
              <Card bordered={false} dis-hover padding={0} class="item">
                <strong>内容</strong>
                <Card dis-hover padding={5} style={{ marginTop: '10px' }}>
                  {row.content}
                </Card>
              </Card>
            </Card>
          </div>
        ),
      })
    },
    async handleSwitch(row) {
      let q = {}
      q.kv = row.id
      q.is_choiceness = !row.is_choiceness - 0
      let res = await $utils.api.load('admin/api/water/edit', q, 'post')
      if (code == 1) {
      }
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  font-size: 24px;
  margin-bottom: 1em;
}
.renBox {
  .water_num {
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #3e8bed;
    padding: 5px 10px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: 700;
    color: #3e8bed;
    margin-right: 10px;
  }
  .item {
    margin-bottom: 20px;
  }
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.name {
  max-width: 100px;
}
</style>
